module.exports = __webpack_public_path__ + "static/img/arrow-right-grey2.9c69707.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/arrow-right-grey2.png
// module id = OzHQ
// module chunks = 1